import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-journal-range',
  templateUrl: './journal-range.component.html',
  styleUrls: [],
  standalone: false
})
export class JournalRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
